import { Injectable } from '@angular/core';
import { combineQueries, QueryEntity } from '@datorama/akita';
import { InstrumentsStore, InstrumentsState } from './instruments.store';
import { map } from 'rxjs/operators';
import { CompaniesQuery } from './companies.query';

@Injectable({ providedIn: 'root' })
export class InstrumentsQuery extends QueryEntity<InstrumentsState> {
    constructor(
        protected store: InstrumentsStore,
        private companiesQuery: CompaniesQuery
    ) {
        super(store);
    }

    /**
     * Checks if the instrument with a given name already exists
     * (compares with lowercase and trimmed name)
     * @param name
     */
    exists(name: string) {
        return this.selectAll({
            filterBy: (entity) =>
                entity.name?.trim().toLowerCase() === name?.trim().toLowerCase()
        }).pipe(map((entities) => entities.length > 0));
    }

    selectSubInstruments() {
        return combineQueries([
            this.selectAll(),
            this.companiesQuery.selectActive()
        ]).pipe(
            map(([instruments, activeCompany]) => {
                return instruments.filter(
                    (instrument) =>
                        instrument.underlyingInstrumentId ===
                            activeCompany?.instrumentId &&
                        instrument.type === 'PRIVATE_EQUITY'
                );
            })
        );
    }
}
